import { ErrorMessage } from '@shared/components/ErrorMessage';
import { Table } from './Table';
import { useGetInsuranceCarriers, useGetAvailableInsuranceCarriers } from '@features/insuranceCarriers/hooks/useInsuranceCarriers';

export const InsuranceCarriersAdminV2 = () => {
  const insuranceCarriersQuery = useGetInsuranceCarriers({ admin: true });
  const availableInsuranceCarriersQuery = useGetAvailableInsuranceCarriers();

  const isFetching = insuranceCarriersQuery.isFetching || availableInsuranceCarriersQuery.isFetching;
  const isError = insuranceCarriersQuery.isError || availableInsuranceCarriersQuery.isError;
  const error = insuranceCarriersQuery.error || availableInsuranceCarriersQuery.error;

  if (isError) return <ErrorMessage error={error} />;

  const records = [
    ...(insuranceCarriersQuery.data || []),
    ...(availableInsuranceCarriersQuery.data || []),
  ];

  return <Table records={records} loading={isFetching} />;
};
